import React, { Fragment } from "react";
import Label from "./Label";

const Select = props => {
  function renderOptions(props) {
    const { placeholder, options, loading } = props;

    if (loading) {
      return (
        <option key={0} value="" disabled>
          Loading...
        </option>
      );
    }

    return (
      <>
        <option key={0} value="">
          {placeholder}
        </option>
        {options.map(option => {
          let value;
          let text;
          if (option.id) {
            value = option.id;
            text = option.description;
          } else {
            value = option;
            text = option;
          }

          return (
            <option key={value} value={value} label={text}>
              {text}
            </option>
          );
        })}
      </>
    );
  }

  return (
    <Fragment>
      <Label htmlFor={props.name} required={props.required}>
        {props.label}
      </Label>
      <select
        id={props.name}
        name={props.name}
        value={props.value}
        onChange={props.handleChange}
        className="form-control"
      >
        {renderOptions(props)}
      </select>
    </Fragment>
  );
};

export default Select;
